import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import StyledLabel from 'components/atoms/inputs/Label';
import DebounceField from 'redux-form-debounce-field';
import TextInputAdmin from 'components/atoms/inputs/TextInputAdmin';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import SelectList from 'components/atoms/inputs/SelectList';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { REGIONALDASHBOARD_ACCESS } from 'constants/capabilities';
import SortedBrandProviderContainer from 'containers/forms/brands/SortedBrandProviderContainer';

const RegionalDashboardProtectedComponent = ProtectedComponent({
    requiredCapabilities: [REGIONALDASHBOARD_ACCESS]
})(props => (<React.Fragment>{props.children}</React.Fragment>));

const General = props => (
    <React.Fragment>
        <Row>
            <Col xs={12}>
                <FormSectionHeading>General</FormSectionHeading>
            </Col>
        </Row>
        <Row>
            <Col xs={12}>
                <StyledLabel required>Entity Name</StyledLabel><br/>
                <DebounceField wait={250} component={TextInputAdmin} name="name" type="text" autocomplete="nope" required={true} />
            </Col>
        </Row>
        <Row>
            <Col md={6}>
                <StyledLabel required>Sales Email</StyledLabel><br />
                <DebounceField wait={250} component={TextInputAdmin} name="salesEmail" type="text" required={true}/>
            </Col>
            <Col md={6}>
                <StyledLabel>Contact Email</StyledLabel><br />
                <DebounceField wait={250} component={TextInputAdmin} name="contactEmail" type="text" required={false}/>
            </Col>
        </Row>
        <RegionalDashboardProtectedComponent>
            <Row>
                <SortedBrandProviderContainer selectedBrandId={props.selectedBrandId}>
                    {({ brandList, brandAliases }) => {
                        const result = [
                            <Col xs={12} md={6} key="generalbrandselection">
                                <StyledLabel>Brand</StyledLabel><br />
                                <Field component={SelectList} list={brandList}
                                    name='brandId' >
                                </Field>
                            </Col>
                        ];

                        if (brandAliases.length > 0) {
                            result.push(
                                <Col xs={12} md={6} key="generalbrandaliasselection">
                                    <StyledLabel required>Layer Type</StyledLabel><br />
                                    <Field
                                        component={SelectList}
                                        list={brandAliases}
                                        name='brandAliasId'
                                        nameTransform={ alias => `${alias.name} (L${alias.layer})` }
                                    />
                                </Col>
                            );
                        }
                        return result;
                    }}
                </SortedBrandProviderContainer>
            </Row>
        </RegionalDashboardProtectedComponent>
    </React.Fragment>
);

General.propTypes = {
    sortedBrands: PropTypes.array,
    sortedBrandAliases: PropTypes.array
};

export default General;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/General.js